import { createFileRoute, Outlet, useMatches } from '@tanstack/react-router'

import { env } from '@/config'
import { SettingsProvider } from '@/contexts/SettingsContext'
import { LIFFProvider } from '@/lib/liff/provider'

export const Route = createFileRoute('/_liff')({
  component: RouteComponent,
})

function RouteComponent() {
  const matches = useMatches()
  const authRequired = !matches.some(
    (match) => (match.staticData as any)?.authRequired === false,
  )

  return (
    <LIFFProvider
      liffId={env.VITE_LIFF_ID}
      withLogin={authRequired}
    >
      <SettingsProvider>
        <Outlet />
      </SettingsProvider>
    </LIFFProvider>
  )
}
